export default "__VITE_ASSET__CLPSckUe__"